import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';

import {AlertSkeleton, ButtonSkeleton} from '..';
import {Alert} from '../index';
import {useGetAnnouncements} from '../../hooks';

const useStyles = makeStyles(theme => ({
    root: {
        listStyle: 'none',
        padding: 0,
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

export interface AnnouncementWarningBarsProps {}

const AnnouncementWarningBars: React.FC<AnnouncementWarningBarsProps> = props => {
    const styles = useStyles();
    const [mounted, setMounted] = useState(false);
    const {isLoading, announcements} = useGetAnnouncements();

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted || !announcements.length) {
        return null;
    }

    return (
        <ul id="announcements" className={styles.root}>
            {isLoading ? (
                <AlertSkeleton AlertProps={{action: <ButtonSkeleton />}} />
            ) : (
                <>
                    {announcements.map((announcement, index) => (
                        <Alert
                            CollapseProps={{component: 'li'}}
                            key={`Announcement-${index}`}
                            type={`ANNOUNCEMENT-${announcement.key}`}
                            severity={announcement.severity}
                            closeable={announcement.closeable}
                            message={<p>{announcement.message}</p>}
                            cta={
                                announcement.ctaLink && {
                                    link: announcement.ctaLink,
                                    message: announcement.ctaMessage
                                }
                            }
                        />
                    ))}
                </>
            )}
        </ul>
    );
};

export default AnnouncementWarningBars;
